/* eslint-disable jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
// import {clearAllBodyScrollLocks} from "body-scroll-lock";
import ReactPlayer from 'react-player';
// import {filterUrl, isInternalLink} from "../../helpers/filters";
import {getVideoId} from "../../helpers/video";
import IconArrowSVG from '../../../public/images/global/icon__arrow.svg';

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentVideoCarousel {
          fieldVideoItems {
            ... on FieldParagraphFieldVideoItems {
              entity {
                ... on Paragraph {
                  ... on Paragraph {
                    ... on ParagraphInnerVideoCarouselItem {
                      fieldTxtHeadline
                      fieldThumbnailImage {
                        ... on FieldParagraphFieldThumbnailImage {
                          entity {
                            ... on MediaImage {
                              fieldMediaImage {
                                width
                                height
                                url
                                alt
                                title
                              }
                            }
                          }
                        }
                        targetId
                      }
                      fieldMoreInfoLink {
                        ... on FieldParagraphFieldMoreInfoLink {
                          url {
                            path
                            routed
                          }
                          title
                        }
                      }
                      fieldVarVideoLink {
                        title
                        url {
                          routed
                          path
                        }
                      }
                      fieldVideoLength
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentVideoCarousel extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired
    };

    static defaultProps = {
        componentIndex: null
    };

    constructor(props) {
        super(props);
        this.videoCarouselRef = React.createRef();
    }

    state = {
        activeVideoIndex: -1,
        playVideo: false,
        secondsCurrentVideoHasPlayed: 0,
        longestPercentageViewed: 0,
        viewedThirtySecondsAndMoreThanHalfOfVideo: false,
        eventHasRunStarted: false,
        eventHasRunQuarter: false,
        eventHasRunHalf: false,
        eventHasRunThreeQuarters: false,
        eventHasRunComplete: false
    };

    /**
     * Select a Video and Autoplay it after scrolling to top
     *
     * @param index
     */
    selectVideo = (index) => {
        this.setState({
            activeVideoIndex: index,
        });
    };

    /**
     * Video Progress Event, fires every second.
     *
     * @param id
     * @param progress
     */
    handleVideoProgress = (id, progress) => {
        const percentagePlayed = Math.round(progress.played * 100);

        // 25%
        if (this.state.longestPercentageViewed >= 25 && !this.state.eventHasRunQuarter) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'maVimeoProgress',
                'progressVimeoID': id,
                'progressAmount': '25%'
            });
            this.setState({eventHasRunQuarter: true});
        }

        // 50%
        if (this.state.longestPercentageViewed >= 50 && !this.state.eventHasRunHalf) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'maVimeoProgress',
                'progressVimeoID': id,
                'progressAmount': '50%'
            });
            this.setState({eventHasRunHalf: true});
        }

        // 75%%
        if (this.state.longestPercentageViewed >= 75 && !this.state.eventHasRunThreeQuarters) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'maVimeoProgress',
                'progressVimeoID': id,
                'progressAmount': '75%'
            });
            this.setState({eventHasRunThreeQuarters: true});
        }

        // Greater than 50% and Viewed at least 30 seconds
        if (this.state.longestPercentageViewed >= 50 && this.state.secondsCurrentVideoHasPlayed >= 30 && !this.state.viewedThirtySecondsAndMoreThanHalfOfVideo) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'maVimeoProgress',
                'progressVimeoID': id,
                'progressAmount': '30s'
            });
            this.setState({viewedThirtySecondsAndMoreThanHalfOfVideo: true})
        }

        // Increment seconds played counter and longest percentage reached
        this.setState({
            secondsCurrentVideoHasPlayed: this.state.secondsCurrentVideoHasPlayed += 1,
            longestPercentageViewed: percentagePlayed > this.state.longestPercentageViewed ? percentagePlayed : this.state.longestPercentageViewed
        });
    };

    handleVideoStart = (id) => {
        this.resetVideoState();

        if (this.state.eventHasRunStarted) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'maVimeoProgress',
            'progressVimeoID': id,
            'progressAmount': 'started'
        });

        this.setState({eventHasRunStarted: true});
    };

    handleVideoEnded = (id) => {
        if (this.state.eventHasRunComplete) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'maVimeoProgress',
            'progressVimeoID': id,
            'progressAmount': 'completed'
        });

        this.setState({eventHasRunComplete: true});
    };

    resetVideoState = () => {
        this.setState({
            secondsCurrentVideoHasPlayed: 0,
            longestPercentageViewed: 0,
            viewedThirtySecondsAndMoreThanHalfOfVideo: false,
            eventHasRunStarted: false,
            eventHasRunQuarter: false,
            eventHasRunHalf: false,
            eventHasRunThreeQuarters: false,
            eventHasRunComplete: false
        });
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;
                    const videoCarouselItems = field.fieldVideoItems && field.fieldVideoItems.length ? field.fieldVideoItems.map(component => component.entity) : [];

                    markComponentLoadedAs(id, true);

                    if (!videoCarouselItems.length) return null;
                    if (videoCarouselItems.length === 1 && (!videoCarouselItems[0].fieldVarVideoLink || !videoCarouselItems[0].fieldThumbnailImage)) return null;

                    return (

                        <section className="yitm__section yitm__videos" ref={this.videoCarouselRef}>

                            {/* Old Carousel Featured Video Code */}
                            {/* {activeVideo && (activeVideo.fieldVarVideoLink || activeVideo.fieldThumbnailImage) ? (
                                <div className="yitm__videos--feat">
                                    <div className="yitm__videoWrapper--feat">

                                        {this.state.playVideo && activeVideoLink && activeVideoLink.type === 'vimeo' ? (
                                            <ReactPlayer controls
                                                         progressInterval={1000}
                                                         loop={false}
                                                         onStart={() => this.handleVideoStart(activeVideoLink.id)}
                                                         onProgress={progress => this.handleVideoProgress(activeVideoLink.id, progress)}
                                                         onEnded={() => this.handleVideoEnded(activeVideoLink.id)}
                                                         url={`https://player.vimeo.com/video/${activeVideoLink.id}?title=0&byline=0&portrait=0&autoplay=1`}
                                                         playing/>
                                        ) : null}

                                        {!this.state.playVideo && activeVideoLink ? (
                                            <button type="button" onClick={() => this.setState({playVideo: true})} style={{backgroundImage: activeVideo.fieldThumbnailImage && activeVideo.fieldThumbnailImage.entity && activeVideo.fieldThumbnailImage.entity.fieldMediaImage && activeVideo.fieldThumbnailImage.entity.fieldMediaImage.url ? `url(${activeVideo.fieldThumbnailImage.entity.fieldMediaImage.url})` : null}}>
                                                <span>Play Video</span>
                                                <img src="/public/images/components/playButton.svg" alt="Play Video"/>
                                            </button>
                                        ) : null}

                                    </div>
                                    <div className="yitm__videoText--feat">
                                        <div className="container">
                                            {activeVideo.fieldTxtHeadline ? (<h2>{activeVideo.fieldTxtHeadline}</h2>) : null}
                                            <div className="yitm__videoDetails--feat">
                                                {activeVideo.fieldVideoLength ? (<span>{activeVideo.fieldVideoLength}</span>) : null}
                                                {activeVideo.fieldMoreInfoLink && activeVideo.fieldMoreInfoLink.url && activeVideo.fieldMoreInfoLink.url.path ? (
                                                    <a target={isInternalLink(activeVideo.fieldMoreInfoLink.url.path) ? '_self' : '_blank'}
                                                       rel={isInternalLink(activeVideo.fieldMoreInfoLink.url.path) ? null : 'noopener noreferrer'}
                                                       href={filterUrl(activeVideo.fieldMoreInfoLink.url.path)}>
                                                        {activeVideo.fieldMoreInfoLink.title} <IconArrowSVG/>
                                                    </a>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ) : null} */}

                            {videoCarouselItems.length ? (
                                <section className={`yitm__videoGrid yitm__videoGrid--items-0${videoCarouselItems.length}`}>

                                        {videoCarouselItems.map((videoCarouselItem, index) => {
                                            if (!(videoCarouselItem.fieldVarVideoLink && videoCarouselItem.fieldVarVideoLink.url && videoCarouselItem.fieldVarVideoLink.url.path)) return null;

                                            const currentVideo = getVideoId(videoCarouselItem.fieldVarVideoLink.url.path);

                                            return (
                                                <div className="yitm__video--slide">
                                                    <button className="yitm__videoTarget--slide" type="button" onClick={() => this.selectVideo(index)}>
                                                        
                                                        <div className="yitm__videoImage--slide">
                                                            <div className="yitm__video">
                                                                <div className="yitm__videoWrapper">
                                                                    <ReactPlayer controls
                                                                                progressInterval={1000}
                                                                                loop={false}
                                                                                onStart={() => this.handleVideoStart(currentVideo.id)}
                                                                                onProgress={progress => this.handleVideoProgress(currentVideo.id, progress)}
                                                                                onEnded={() => this.handleVideoEnded(currentVideo.id)}
                                                                                url={`https://player.vimeo.com/video/${currentVideo.id}?title=0&byline=0&portrait=0&autoplay=1`}
                                                                                playing={this.state.activeVideoIndex === index}
                                                                                />

                                                                    {this.state.activeVideoIndex !== index && currentVideo ? (
                                                                        <button type="button" style={{backgroundImage: videoCarouselItem.fieldThumbnailImage && videoCarouselItem.fieldThumbnailImage.entity && videoCarouselItem.fieldThumbnailImage.entity.fieldMediaImage && videoCarouselItem.fieldThumbnailImage.entity.fieldMediaImage.url ? `url(${videoCarouselItem.fieldThumbnailImage.entity.fieldMediaImage.url})` : null}}>
                                                                            <span>Play Video</span>
                                                                            <img src="/public/images/components/playButton.svg" alt="Play Video"/>
                                                                        </button>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="yitm__videoText--slide">
                                                            {videoCarouselItem.fieldTxtHeadline ? (<h3>{videoCarouselItem.fieldTxtHeadline}</h3>) : null}
                                                            <div className="yitm__videoDetails--slide">
                                                                {videoCarouselItem.fieldVideoLength ? (<span>{videoCarouselItem.fieldVideoLength}</span>) : null}
                                                                <span>Play Video <IconArrowSVG/></span>
                                                            </div>
                                                        </div>
                                                        
                                                    </button>
                                                </div>
                                            );
                                        })}

                                </section>
                            ) : null}

                        </section>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentVideoCarousel;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentVideoCarousel.jsx